import Vue from 'vue';

export function addProduct(state, product) {
  state.products.push(product);
}

export function updateProduct(state, { product, index }) {
  Vue.set(
    state.products,
    state.products.findIndex(p => p.uid === index),
    product,
  );
}

export function updateLastOrder(state, payload) {
  state.lastOrder = payload;
}

export function flushProducts(state) {
  state.products = [];
}

export function flush(state) {
  state.products = [];
  state.coupon = null;
  state.deliveryMethod = null;
  state.paymentMethodId = 1;
  state.useCredit = false;
  state.currentProductIndex = null;
  state.currentSelectedOptions = null;
  state.currentSelectedSideOptions = null;
  state.currentProductQuantity = null;
  state.totalPrice = 0;
  state.totalDiscount = 0;
  state.distancing = 0;
}

export function removeProductFromCart(state, payload) {
  state.products.splice(payload, 1);
}

export function updateTotalPrice(state, payload) {
  state.totalPrice = payload;
}

export function updateTotalDiscount(state, payload) {
  state.totalDiscount = payload;
}

export function setValidCouponCode(state, payload) {
  state.coupon = payload;
}

export function setCreditFlag(state, payload) {
  state.useCredit = payload;
}

export function toggleDistancing(state) {
  state.distancing = !state.distancing;
}

export function setDistancing(state, payload) {
  state.distancing = payload;
}

export function setSelectedOptions(state, payload) {
  state.currentSelectedOptions = payload;
}

export function setSelectedSideOptions(state, payload) {
  state.currentSelectedSideOptions = payload;
}

export function setSelectedProductIndex(state, payload) {
  state.currentProductIndex = payload;
}

export function setDeliveryMethod(state, payload) {
  state.deliveryMethod = payload;
}

export function setSelectedProductQuantity(state, payload) {
  state.currentProductQuantity = payload;
}

export function updateProductQuantity(state, payload) {
  const { uid, quantity } = payload;
  state.products.find(entry => entry.uid === uid).quantity = quantity;
}

export function setPaymentMethod(state, payload) {
  state.paymentMethodId = payload;
}

export function setOrderReadyTime(state, payload) {
  state.readyTime = payload;
}

export function setDeliveryMethodData(state, payload) {
  state.deliveryMethodData = payload;
}

export function updatePaymentData(state, {
  cardNumber, expirationMonth, expirationYear, ccv, phoneNumber, paymentMethodId,
}) {
  if (phoneNumber) {
    state.paymentData = {
      phoneNumber,
    };
  }
  else if (cardNumber && expirationMonth && expirationYear && ccv) {
    const expiration = expirationYear.toString().substr(2, 2) + expirationMonth;
    // eslint-disable-next-line no-param-reassign
    cardNumber = cardNumber.toString().replace(/\D/g, '');

    state.paymentData = {
      cardNumber,
      ccv,
      expiration,
      paymentMethodId,
    };
  }
  else {
    state.paymentData = null;
  }
}
